import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "team_box"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "team_title"
}, "核心团队", -1);

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

var _hoisted_4 = {
  class: "team_content container"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "team_item_name"
};
var _hoisted_8 = {
  class: "team_item_position"
};
var _hoisted_9 = {
  key: 0,
  class: "team_item_position_two"
};
var _hoisted_10 = {
  class: "team_item_university"
};

var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "team_director_title col-lg-12 col-md-12 col-sm-12 col-xs-12",
  id: "dongshi"
}, "董事会成员", -1);

var _hoisted_12 = ["onClick"];
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  class: "team_item_name"
};
var _hoisted_15 = {
  class: "team_item_position"
};
var _hoisted_16 = {
  class: "team_item_university"
};
var _hoisted_17 = {
  class: "pop_meng"
};
var _hoisted_18 = {
  class: "pop_box"
};
var _hoisted_19 = {
  key: 0
};
var _hoisted_20 = {
  class: "pop_top"
};
var _hoisted_21 = {
  class: "pop_top_head"
};
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  class: "pop_top_name"
};
var _hoisted_24 = {
  class: "pop_top_name_a"
};
var _hoisted_25 = {
  key: 0,
  class: "pop_top_name_"
};
var _hoisted_26 = {
  key: 1,
  class: "pop_top_name_"
};
var _hoisted_27 = {
  class: "pop_con_box"
};
var _hoisted_28 = {
  class: "pop_con"
};
var _hoisted_29 = {
  class: "con_name"
};
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = {
  key: 1
};
var _hoisted_32 = {
  class: "pop_top"
};
var _hoisted_33 = {
  class: "pop_top_head"
};
var _hoisted_34 = ["src"];
var _hoisted_35 = {
  class: "pop_top_name"
};
var _hoisted_36 = {
  class: "pop_top_name_a"
};
var _hoisted_37 = {
  class: "pop_top_name_"
};
var _hoisted_38 = {
  key: 0,
  class: "pop_top_name_"
};
var _hoisted_39 = {
  class: "pop_con_box"
};
var _hoisted_40 = {
  class: "pop_con"
};
var _hoisted_41 = {
  class: "con_name"
};
var _hoisted_42 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.teamList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "flex_team col-lg-3 col-md-4 col-sm-6 col-xs-6",
      key: index
    }, [_createElementVNode("div", {
      class: "team_item_box",
      onClick: function onClick($event) {
        return $setup.toggleMore(index, 1);
      }
    }, [_createElementVNode("img", {
      src: item.headImg,
      class: "head_img_box"
    }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.position), 1), item.education != '' ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.education), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, _toDisplayString(item.major), 1)], 8, _hoisted_5)]);
  }), 128)), _hoisted_11, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ceoList, function (item, index) {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "flex_team col-lg-3 col-md-4 col-sm-6 col-xs-6",
      key: index
    }, [_createElementVNode("div", {
      class: "team_item_box",
      onClick: function onClick($event) {
        return $setup.toggleMore(index, 2);
      }
    }, [_createElementVNode("img", {
      src: item.headImg,
      class: "head_img_box"
    }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.position), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(item.major), 1)], 8, _hoisted_12)])), [[_vShow, index <= 3]]);
  }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_vShow, $setup.popFlag]]), _withDirectives(_createElementVNode("div", _hoisted_18, [$setup.types == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
    src: $setup.teamList.length > 0 ? $setup.teamList[$setup.showIndex].headImg : '',
    class: "top_head_img"
  }, null, 8, _hoisted_22)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString($setup.teamList.length > 0 ? $setup.teamList[$setup.showIndex].name : ''), 1), $setup.teamList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.teamList.length > 0 ? $setup.teamList[$setup.showIndex].position : '') + _toDisplayString($setup.teamList[$setup.showIndex].education != '' ? '、' + $setup.teamList[$setup.showIndex].education : ''), 1)) : _createCommentVNode("", true), $setup.teamList[$setup.showIndex].major ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.teamList.length > 0 ? $setup.teamList[$setup.showIndex].major : ''), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
    class: "con_text",
    innerHTML: $setup.teamList.length > 0 ? $setup.teamList[$setup.showIndex].introduction : ''
  }, null, 8, _hoisted_30)])])]), _createElementVNode("div", {
    class: "pop_close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.toggleMore(0);
    })
  })])) : _createCommentVNode("", true), $setup.types == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("img", {
    src: $setup.ceoList.length > 0 ? $setup.ceoList[$setup.showIndex].headImg : '',
    class: "top_head_img"
  }, null, 8, _hoisted_34)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($setup.ceoList.length > 0 ? $setup.ceoList[$setup.showIndex].name : ''), 1), _createElementVNode("div", _hoisted_37, _toDisplayString($setup.ceoList.length > 0 ? $setup.ceoList[$setup.showIndex].position : ''), 1), $setup.ceoList[$setup.showIndex].major ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($setup.ceoList.length > 0 ? $setup.ceoList[$setup.showIndex].major : ''), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", {
    class: "con_text",
    innerHTML: $setup.ceoList.length > 0 ? $setup.ceoList[$setup.showIndex].introduction : ''
  }, null, 8, _hoisted_42)])])]), _createElementVNode("div", {
    class: "pop_close",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.toggleMore(0);
    })
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $setup.popFlag]])]);
}